/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CrmIntegration } from './CrmIntegration.js';
import {
    CrmIntegrationFromJSON,
    CrmIntegrationFromJSONTyped,
    CrmIntegrationToJSON,
} from './CrmIntegration.js';

/**
 * 
 * @export
 * @interface CrmIntegrationsResponse
 */
export interface CrmIntegrationsResponse {
    /**
     * 
     * @type {Array<CrmIntegration>}
     * @memberof CrmIntegrationsResponse
     */
    data?: Array<CrmIntegration>;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CrmIntegrationsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CrmIntegrationsResponse interface.
 */
export function instanceOfCrmIntegrationsResponse(value: object): boolean {
    return true;
}

export function CrmIntegrationsResponseFromJSON(json: any): CrmIntegrationsResponse {
    return CrmIntegrationsResponseFromJSONTyped(json, false);
}

export function CrmIntegrationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmIntegrationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CrmIntegrationFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CrmIntegrationsResponseToJSON(value?: CrmIntegrationsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CrmIntegrationToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

